import { IStoreState } from '../types';

export const getDomainsList = (state: IStoreState) => state.domainsNew.items;
